import React, { FC } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { api } from '@/api';
import { SingleValue } from 'react-select';
import { TLabelAndValue } from '@/types';
import styles from '../../styles/index.module.scss';
import { styleSelectOrders } from '../../const';

interface ISelectOrders {
  className?: string,
  value?: any,
  onChange: (e: SingleValue<TLabelAndValue>) => void;
}

const SelectOrders: FC<ISelectOrders> = ({ value, onChange }) => {

  const loadOptions = async (search: string, { page }: Record<string, any>) => {

    const hasSearchValue = search !== '' ? search : undefined ;
    const { results, next } = await api.order.getOrders({ page, search: hasSearchValue });
    const filteredOptions = results.map((el) => {
      return {
        value: el.id,
        label: el.number
      }
    })

    return {
      options: filteredOptions,
      hasMore: Boolean(next),
      additional: {
        page: page + 1
      }
    };
  }

  return (
    <AsyncPaginate
      isClearable
      placeholder='Выберите'
      loadOptions={loadOptions}
      onChange={onChange}
      defaultValue={[value]}
      additional={{
        page: 1,
      }}
      noOptionsMessage={() => 'Ничего не найдено'}
      loadingMessage={() => 'Поиск...'}
      className={styles['item-select']}
      styles={styleSelectOrders}
      name='customer'
    />
  );
}

export default SelectOrders;